import { render, staticRenderFns } from "./NotepadContainer.vue?vue&type=template&id=af4e858c&"
import script from "./NotepadContainer.vue?vue&type=script&lang=js&"
export * from "./NotepadContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports